export default Object.freeze({
	authentication: 'authentication',
	localization: 'localization',
	translations: 'translations',
	product: 'product',
	storeAvailability: 'storeAvailability',
	store: 'store'
});
